import React, { useState, useEffect } from "react";
import { ReactComponent as Arrow } from "../../assets/icons/expand_more-24px.svg";
import { ReactComponent as FAQIcon } from "../../assets/icons/FAQ.svg";
import { ApiCall } from "../../Redux/Actions/ApiCall";
import { urls } from "../../Utils/url";
import { CSSTransition } from "react-transition-group";
import { setFAQ } from "../../Redux/Actions";
import { connect } from "react-redux";
const getFAQ = (setData, setFAQs) => {
  ApiCall("get", urls.getFAQ, null, "get Faq", null, (e) => {
    if (e.data) {
      setFAQs(e.data.content);
      setData(e.data.content);
    }
  });
};
const FAQComponent = ({ data, selected, setSelected, index }) => {
  return (
    <div className={"FAQComponent"}>
      <div
        onClick={() => {
          selected ? setSelected() : setSelected(index);
        }}
        className="FAQComponentHeader"
        style={{
          backgroundColor: selected && "#2c3e50",
          color: selected && "white",
        }}
      >
        <Arrow
          fill={selected ? "white" : "black"}
          style={
            selected
              ? { transform: "rotate(-180deg)" }
              : { transform: "rotate(0)" }
          }
        />
        <span>{data.title}</span>
      </div>
      {/* <CSSTransition
        in={selected}
        timeout={300}
        classNames="AnimateSpan"
        unmountOnExit
      > */}
      {selected && (
        <div className="AnimateSpan">
          <span>{data.full_text}</span>
        </div>
      )}
      {/* </CSSTransition> */}
    </div>
  );
};

const FAQ = ({ FAQs, setFAQs }) => {
  const [selected, setSelected] = useState();
  const [data, setData] = useState(FAQs);
  useEffect(() => {
    if (navigator.onLine) {
      getFAQ(setData, setFAQs);
    }
  }, []);
  return (
    <div className="FAQ">
      <div>
        <FAQIcon />
        <span>سوالات متداول</span>
      </div>
      <div>
        {data &&
          data.map((item, index) => (
            <FAQComponent
              data={item}
              selected={selected === index}
              setSelected={setSelected}
              index={index}
            />
          ))}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    FAQs: state.auth.faq,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setFAQs: (data) => dispatch(setFAQ(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FAQ);
